<template>
  <div>
    <template>
      <advertisement-top-banner />
    </template>
    <div>
      <b-container class="home">
        <b-row class="mx-3">
          <h5 class="category">{{ this.$route.params.category }}</h5>

          <b-col md="3" class="search-options">
            <b-form-select
              v-model="selected"
              :options="options1"
              @input="onSelectProductType"
              class="mt-1"
            ></b-form-select>
          </b-col>
          <b-col md="3">
            <b-form-input
              class="search-storeinput mt-1"
              placeholder="Search Product..."
              v-model="storeName"
            ></b-form-input>
            <button
              class="col search-button mt-3 border-radius-r-40"
              @click="onSearch"
            >
              <b-icon icon="search" class="margin-top-4"></b-icon>
            </button>
          </b-col>
          <b-col md="3" class="search-options mt-1">
            <b-form-select
              class="form-select filter-select form-control border"
              v-model="selected2"
              :options="options2"
              @input="onChangeSort($event)"
            ></b-form-select>
          </b-col>
        </b-row>
      </b-container>
      <template v-if="$options.components['advertisement-loading']">
        <advertisement-loading v-if="isLoading" />
      </template>
    </div>
    <div class="row padding" v-if="categoryitemList">
      <div
        class="col-md-3"
        v-for="(item, index) in categoryitemList"
        :key="index"
      >
        <div class="item">
          <router-link
            style="text-decoration: none; color: inherit"
            :to="{
              name: `product-view`,
              params: {
                data: item.slug || item._id,
              },
            }"
          >
            <div
              class="stock"
              v-if="
                item.Availability &&
                item.Availability.toLowerCase().trim() === 'out of stock'
              "
            >
              <svg
                width="100"
                height="20"
                viewBox="0 0 150 75"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <line
                  x1="106"
                  y1="8.74228e-08"
                  x2="106"
                  y2="219"
                  stroke="#EB594C"
                  stroke-width="4"
                />
                <rect
                  x="99"
                  y="159"
                  width="14"
                  height="30"
                  rx="5"
                  fill="#EB594C"
                />
                <rect
                  x="99"
                  y="114"
                  width="14"
                  height="30"
                  rx="5"
                  fill="#EB594C"
                />
                <rect
                  x="99"
                  y="69"
                  width="14"
                  height="30"
                  rx="5"
                  fill="#EB594C"
                />
                <rect
                  x="99"
                  y="24"
                  width="14"
                  height="30"
                  rx="5"
                  fill="#EB594C"
                />
                <circle cx="103" cy="309" r="103" fill="#EB594C" />
                <circle
                  cx="103"
                  cy="309"
                  r="87"
                  stroke="white"
                  stroke-width="4"
                  stroke-dasharray="8 8"
                />
                <path
                  d="M89.3809 260.396C89.3809 264.146 88.3086 267.246 86.1641 269.695C84.0195 272.145 81.2129 273.369 77.7441 273.369C74.2871 273.369 71.4922 272.145 69.3594 269.695C67.2383 267.246 66.1777 264.146 66.1777 260.396V260.01C66.1777 256.283 67.2383 253.189 69.3594 250.729C71.4805 248.268 74.2695 247.037 77.7266 247.037C81.1953 247.037 84.002 248.268 86.1465 250.729C88.3027 253.189 89.3809 256.283 89.3809 260.01V260.396ZM84.2656 259.975C84.2656 257.326 83.7148 255.176 82.6133 253.523C81.5117 251.871 79.8828 251.045 77.7266 251.045C75.5703 251.045 73.959 251.865 72.8926 253.506C71.8379 255.146 71.3105 257.303 71.3105 259.975V260.396C71.3105 263.092 71.8438 265.266 72.9102 266.918C73.9883 268.559 75.5996 269.379 77.7441 269.379C79.9121 269.379 81.541 268.559 82.6309 266.918C83.7207 265.266 84.2656 263.092 84.2656 260.396V259.975ZM101.738 247.406V250.5L98.9961 251.027V264.387C98.9961 266.074 99.4473 267.34 100.35 268.184C101.264 269.016 102.512 269.432 104.094 269.432C105.699 269.432 106.959 269.016 107.873 268.184C108.787 267.352 109.244 266.086 109.244 264.387V251.027L106.52 250.5V247.406H117.119V250.5L114.377 251.027V264.387C114.377 267.258 113.428 269.473 111.529 271.031C109.643 272.59 107.164 273.369 104.094 273.369C101.035 273.369 98.5625 272.59 96.6758 271.031C94.8008 269.473 93.8633 267.258 93.8633 264.387V251.027L91.1387 250.5V247.406H93.8633H98.9961H101.738ZM141.184 247.406V254.227H137.246L137.035 251.361H132.324V269.396L135.066 269.924V273H124.449V269.924L127.191 269.396V251.361H122.498L122.287 254.227H118.367V247.406H141.184Z"
                  fill="white"
                />
                <path
                  d="M102.381 301.396C102.381 305.146 101.309 308.246 99.1641 310.695C97.0195 313.145 94.2129 314.369 90.7441 314.369C87.2871 314.369 84.4922 313.145 82.3594 310.695C80.2383 308.246 79.1777 305.146 79.1777 301.396V301.01C79.1777 297.283 80.2383 294.189 82.3594 291.729C84.4805 289.268 87.2695 288.037 90.7266 288.037C94.1953 288.037 97.002 289.268 99.1465 291.729C101.303 294.189 102.381 297.283 102.381 301.01V301.396ZM97.2656 300.975C97.2656 298.326 96.7148 296.176 95.6133 294.523C94.5117 292.871 92.8828 292.045 90.7266 292.045C88.5703 292.045 86.959 292.865 85.8926 294.506C84.8379 296.146 84.3105 298.303 84.3105 300.975V301.396C84.3105 304.092 84.8438 306.266 85.9102 307.918C86.9883 309.559 88.5996 310.379 90.7441 310.379C92.9121 310.379 94.541 309.559 95.6309 307.918C96.7207 306.266 97.2656 304.092 97.2656 301.396V300.975ZM104.438 310.924L107.162 310.396V292.027L104.438 291.5V288.406H124.811V295.42H120.873L120.645 292.361H112.295V299.41H121.26V303.365H112.295V310.396L115.037 310.924V314H104.438V310.924Z"
                  fill="white"
                />
                <path
                  d="M63.4258 337.58H59.5762L58.9082 334.064C58.4629 333.783 57.8125 333.537 56.957 333.326C56.1016 333.115 55.1934 333.01 54.2324 333.01C52.8262 333.01 51.7363 333.309 50.9629 333.906C50.2012 334.492 49.8203 335.254 49.8203 336.191C49.8203 337.059 50.2188 337.773 51.0156 338.336C51.8242 338.887 53.2129 339.473 55.1816 340.094C58.0059 340.879 60.1445 341.916 61.5977 343.205C63.0625 344.494 63.7949 346.188 63.7949 348.285C63.7949 350.477 62.9277 352.205 61.1934 353.471C59.459 354.736 57.1738 355.369 54.3379 355.369C52.3105 355.369 50.4766 355.047 48.8359 354.402C47.207 353.758 45.8477 352.867 44.7578 351.73V346.387H48.7305L49.2754 350.025C49.791 350.447 50.4883 350.799 51.3672 351.08C52.2578 351.35 53.248 351.484 54.3379 351.484C55.7441 351.484 56.8105 351.197 57.5371 350.623C58.2754 350.049 58.6445 349.281 58.6445 348.32C58.6445 347.336 58.293 346.545 57.5898 345.947C56.8984 345.35 55.6797 344.787 53.9336 344.26C50.8984 343.381 48.6016 342.338 47.043 341.131C45.4844 339.924 44.7051 338.271 44.7051 336.174C44.7051 334.1 45.584 332.406 47.3418 331.094C49.0996 329.77 51.3086 329.09 53.9688 329.055C55.9375 329.055 57.7305 329.354 59.3477 329.951C60.9648 330.549 62.3242 331.346 63.4258 332.342V337.58ZM88.3516 329.406V336.227H84.4141L84.2031 333.361H79.4922V351.396L82.2344 351.924V355H71.6172V351.924L74.3594 351.396V333.361H69.666L69.4551 336.227H65.5352V329.406H88.3516ZM112.943 342.396C112.943 346.146 111.871 349.246 109.727 351.695C107.582 354.145 104.775 355.369 101.307 355.369C97.8496 355.369 95.0547 354.145 92.9219 351.695C90.8008 349.246 89.7402 346.146 89.7402 342.396V342.01C89.7402 338.283 90.8008 335.189 92.9219 332.729C95.043 330.268 97.832 329.037 101.289 329.037C104.758 329.037 107.564 330.268 109.709 332.729C111.865 335.189 112.943 338.283 112.943 342.01V342.396ZM107.828 341.975C107.828 339.326 107.277 337.176 106.176 335.523C105.074 333.871 103.445 333.045 101.289 333.045C99.1328 333.045 97.5215 333.865 96.4551 335.506C95.4004 337.146 94.873 339.303 94.873 341.975V342.396C94.873 345.092 95.4062 347.266 96.4727 348.918C97.5508 350.559 99.1621 351.379 101.307 351.379C103.475 351.379 105.104 350.559 106.193 348.918C107.283 347.266 107.828 345.092 107.828 342.396V341.975ZM135.971 338.037H132.156L131.629 334.627C131.125 334.123 130.486 333.725 129.713 333.432C128.951 333.139 128.049 332.992 127.006 332.992C124.779 332.992 123.062 333.801 121.855 335.418C120.66 337.035 120.062 339.145 120.062 341.746V342.643C120.062 345.244 120.66 347.359 121.855 348.988C123.051 350.617 124.738 351.432 126.918 351.432C127.926 351.432 128.846 351.285 129.678 350.992C130.521 350.699 131.172 350.301 131.629 349.797L132.156 346.387H135.971V351.449C134.939 352.645 133.621 353.6 132.016 354.314C130.422 355.018 128.635 355.369 126.654 355.369C123.221 355.369 120.408 354.18 118.217 351.801C116.025 349.422 114.93 346.369 114.93 342.643V341.781C114.93 338.066 116.02 335.014 118.199 332.623C120.379 330.232 123.197 329.037 126.654 329.037C128.635 329.037 130.422 329.4 132.016 330.127C133.609 330.842 134.928 331.791 135.971 332.975V338.037ZM138.344 351.924L141.068 351.396V333.027L138.344 332.5V329.406H148.803V332.5L146.201 333.027V339.865H148.434L153.355 332.711L151.844 332.5V329.406H161.986V332.5L159.209 332.975L152.916 341.377L159.982 351.484L162.549 351.924V355H152.406V351.924L153.988 351.713L149.066 344.312H146.201V351.396L148.803 351.924V355H138.344V351.924Z"
                  fill="white"
                />
              </svg>
            </div>
            <div
              class="show-variant"
              v-if="
                item && item.variations && item.variations.length > 1
                  ? true
                  : false
              "
            >
              <span class="variant-span"
                >{{
                  item && item.variations && item.variations.length > 1
                    ? item.variations.length
                    : ""
                }}
                {{ $t("variants") }}</span
              >
            </div>
            <b-img
              :src="item.images.smallImage"
              class="item-image"
              width="64"
              alt="placeholder"
            ></b-img>

            <div class="item-no-bg-img-overlay">
              <div v-if="item['Discount(%)']" class="item-no-bg-discountbox">
                <p class="text-icon price">
                  {{ currency.symbol }}
                  {{ item["Discount(%)"] }} {{ currency.code }} off
                </p>
              </div>
            </div>

            <h6 class="mt-3 mb-1 item-name text-center">
              {{ item.Name.slice(0, 12) }}
            </h6>

            <div
              class="d-flex justify-content-center mb-2"
              v-if="item['Discount(%)']"
            >
              <del class="text-icon price mr-2">
                {{ item.Price }} {{ currency.code }}
              </del>

              <h5 class="text-icon price mb-0">
                {{ currency.symbol }}{{ item["Deal Price"] }}
                {{ currency.code }}
              </h5>
            </div>
            <div class="d-flex justify-content-center" v-else>
              <h5 class="text-icon price">
                {{ currency.symbol }}
                {{ item.Price }} {{ currency.code }}
              </h5>
            </div>
          </router-link>
          <div
            class="text-center"
            v-if="
              item.Availability &&
              item.Availability.toLowerCase().trim() === 'out of stock'
            "
          >
            <p class="text-danger font-weight-bold">
              {{ $t("wishlistProductavailability.outOfStock") }}
            </p>
          </div>

          <div v-else>
            <template
              v-if="$options.components['checkout-increment-decrement']"
            >
              <checkout-increment-decrement
                id="button-color"
                :callCheckout="false"
                :cartItem="item"
                :key="index"
              />
            </template>
          </div>
        </div>
      </div>
    </div>
    <div v-if="categoryitemList.length == 0" class="text-center no-item">
      {{ $t("productStore.noItmes") }}
    </div>
    <div v-if="categoryitemList.length == 20">
      <ul class="pagination d-flex justify-content-center">
        <li class="page-item">
          <div
            class="page-link pointer"
            href="#"
            aria-label="Previous"
            @click="onClickleftArrow"
          >
            {{ $t("prev") }}
          </div>
        </li>
        <li class="page-item">
          <a class="page-link pointer" href="#">{{ this.currentPage }}</a>
        </li>
        <li class="page-item">
          <div
            class="page-link pointer"
            href="#"
            aria-label="Next"
            @click="onClickRightArrow"
          >
            {{ $t("next") }}
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  name: "category-view",
  data() {
    return {
      productTypeList: "",
      storeName: "",
      currentPage: 1,
      pageNo: "",
      selected: null,
      selected2: null,
      isLoading: false,
      options1: [{ text: "All category", value: null }],
      options2: [
        { value: null, text: "Sorting Items" },
        { value: "a-z", text: "Alphabetically, A-Z" },
        { value: "z-a", text: "Alphabetically, Z-A" },
        { value: "low", text: "price, low to high" },
        { value: "high", text: "price, high to low" },
      ],
    };
  },
  created() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  },
  computed: {
    ...mapState({
      categoryitemList: (state) => state.category.categoryitemList,
      categoryList: (state) => state.shopDetails.categoryList,
      allCategoryList: (state) => state.shopDetails.allCategoryList,
      currency: (state) => state.home.currency,
    }),
  },

  methods: {
    async onSelectProductType(e) {
      const payload = {
        category: this.$route.params.category,
        provider: this.$route.params.providerId,
      };
      const data = [payload, this.currentPage];
      await this.$store.dispatch("category/getCategoryItemsList", data);
      if (e != null) {
        this.$store.dispatch("category/filterItemFromProductType", e);
      }
    },
    async onSearch() {
      const payload = {
        category: this.$route.params.category,
        provider: this.$route.params.providerId,
      };
      const data = [payload, this.currentPage];
      await this.$store.dispatch("category/getCategoryItemsList", data);
      this.$store.dispatch("category/search", this.storeName);
    },
    onChangeSort(event) {
      this.$store.dispatch("category/sortProducts", event);
    },
    async onClickRightArrow() {
      this.isLoading = true;
      this.currentPage += 1;
      this.pageNo = this.currentPage;
      const payload = {
        category: this.$route.params.category,
        provider: this.$route.params.providerId,
      };
      const data = [payload, this.pageNo];
      await this.$store.dispatch("category/getCategoryItemsList", data);
      this.isLoading = false;
    },
    async onClickleftArrow() {
      this.isLoading = true;
      if (this.currentPage < 2) {
        this.currentPage == 1;
      } else {
        this.currentPage -= 1;
      }
      this.pageNo = this.currentPage;
      const payload = {
        category: this.$route.params.category,
        provider: this.$route.params.providerId,
      };
      const data = [payload, this.pageNo];
      await this.$store.dispatch("category/getCategoryItemsList", data);
      this.isLoading = false;
    },
  },
  async mounted() {
    this.isLoading = true;
    await this.$store.dispatch(
      "shopDetails/fetchStoreCategoryList",
      this.$route.params.providerId
    );
    let productTypeId = [];
    this.allCategoryList.forEach((element) => {
      if (element.parent._id == this.$route.params.parentId) {
        this.options1.push({ text: element.name, value: element.name });
        productTypeId.push(element._id);
      }
    });
    this.pageNo = this.currentPage;
    const payload = {
      category: this.$route.params.category,
      provider: this.$route.params.providerId,
    };
    const data = [payload, this.pageNo];
    await this.$store.dispatch("category/getCategoryItemsList", data);
    this.isLoading = false;
  },
};
</script>
<style scoped>
.pointer {
  cursor: pointer;
  color: var(--primarycolor);
  font-size: 18px;
  font-weight: 600;
  margin: 10px;
}
.no-item {
  font-family: "roboto";
  font-weight: 800;
  font-size: 24px;
  padding: 80px;
}
.text-grey1 {
  color: #aaa;
  background-color: transparent;
}
.padding {
  padding: 50px;
}
.search-options {
  max-width: 22%;
}
.text-grey {
  background-color: #f9f9f9;
}

.product-listing-div {
  display: block !important;
  width: 100% !important;
}

.search-button {
  position: absolute;
  top: 0;
  font-size: large;
  z-index: 1;
  right: 5px;
  width: 48px;
  height: 40px;
  padding: 0px;
  background-color: var(--primarycolor) !important;
  color: #fff;
}
.search-storeinput {
  border-radius: 30px !important;
  height: 40px;
}
.categoryName {
  margin-left: 10px;
  margin-top: 20px;
  font-size: 30px;
}
.show-variant {
  position: relative;
  color: var(--primarycolor);
}
.variant-span {
  position: absolute;
  background-color: #ffef40;
  padding: 5px 20px 5px 20px;
  font-size: 13px;
  color: #272727;
  top: -10px;
  left: -21px;
  z-index: 1;
  -webkit-clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%, 10% 50%);
  clip-path: polygon(100% 0%, 90% 50%, 100% 100%, 0% 100%, 10% 100%, 10% 0%);
  font-weight: 500;
}
.item-no-bg-discountbox {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 70px;
  height: 30px;
  background-color: var(--primarycolor);
  position: absolute;
  right: 0;
  top: 16px;
}
.item-no-bg-discountbox p::before {
  color: white;
  height: 14px;
}
.item-no-bg-discountbox p {
  color: white;
  font-size: 14px;
  line-height: 14px;
  margin-bottom: 0;
  font-weight: 700;
}

.seller-name {
  margin-right: 12px;
  margin-left: 12px;
}
.seller-name-p {
  color: var(--primarycolor) !important;
}
.bg-lightgray {
  background: #f8f8f8;
}
.category {
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 39px;
  text-transform: capitalize;
  color: var(--primarycolor);
  margin-left: 0px;
  margin-top: 10px;
}
.all {
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  color: var(--primarycolor);
  padding: 15px 15px;
}
.active {
  text-decoration: underline var(--primarycolor) 4px;
  padding: 30px;
}
.text-icon::before {
  color: black;
  width: 10px;
  position: relative;
  right: 3px;
}
.title-text {
  white-space: nowrap;
  width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left;
}
.item-price::before {
  color: var(--primarycolor);
}
.filter {
  font-style: normal;
  margin-top: 20px;
}
.item-container {
  display: flex;
  flex-wrap: wrap;
  margin-left: 60px;
  margin-right: 45px;
}

.item-name {
  width: 150px;
  text-align: center;

  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  margin-left: 0px;
  position: relative;
  text-align: center;
  color: #000000;
}
.item-image {
  height: 148px;
  width: 183px;
}
.item {
  box-sizing: border-box;
  background: #ffffff;
  border: 1px solid #f1f1f1;
  border-radius: 4px;
  padding: 20px;
  display: flex;
  margin-left: 10px;
  margin-bottom: 15px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.percentage-off {
  position: absolute;
  width: 70px;
  height: 30px;
  left: 254px;
  top: 1327.41px;
  background: var(--primarycolor);
  border-radius: 3px 0px 0px 3px;
}
.amount-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 20px;
}
.item-price {
  font-style: normal;
  font-weight: 200;
  font-size: 10px;
  line-height: 15px;
  text-decoration-line: line-through;
  text-transform: capitalize;
  color: #000000;
}
.discount {
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 15px;
  text-transform: capitalize;
  color: #000000;
}
#button-color {
  font-style: normal;
  font-size: 13px;
  width: 230px;
  line-height: 18px;
  text-transform: capitalize;
  color: var(--primarycolor);
  background-color: transparent;
  /* border: 2px solid var(--primarycolor); */
}
.stock {
  z-index: 9999;
}
.no-item {
  font-weight: 800;
  font-size: 24px;
  padding: 80px;
}
.marin-right {
  margin-right: 50px;
}
.stock svg {
  overflow: inherit;
  position: absolute;
  z-index: 1;
  right: 0px;
  animation: rotation 3s infinite linear;
  -webkit-transition: all 3s ease;
  -moz-transition: all 3s ease;
  -o-transition: all 3s ease;
  -ms-transition: all 3s ease;
  transition: all 3s ease;
}
</style>
